var app = angular.module('leonardo');

var ContactRestService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('contacts');

  service.getReports = function(params) {
    return RestangularProvider.all('contacts').customGET('report', params);
  };

  service.resetProperties = function(contactId) {
    return RestangularProvider.one('contacts', contactId).customPOST({}, 'reset-properties');
  };

  return service;
};

app.factory('ContactRestService', ['BaseRestService', 'Restangular', ContactRestService]);
